<article>
    <header>
      <strong>Ranking de Motivos De Contato Micro Mencionados</strong>
    </header>
    <main>
      <app-bar-chart [loading]="isLoading" [error]="error"></app-bar-chart>
    </main>
  </article>
  